import { GhlCalendar } from './GhlCalendar';
import { PhoneButton } from './PhoneButton';
import { CALENDARS } from '../../lib/site';
import { SectionTitle } from './PageHero';

const CONFIG = {
  medicare: { phone: 'medicare', title: 'Book your Medicare consultation', id: 'turning65medicarehelp_booking' },
  retirement: { phone: 'financial', title: 'Book your retirement planning consultation', id: 'retirement_planning_booking' },
};

export const BookingBlock = ({ kind, testid, kicker = 'Schedule', sub }) => {
  const c = CONFIG[kind];
  return (
    <section id="book" style={{ scrollMarginTop: 96 }} data-testid={testid} className="max-w-6xl mx-auto px-5 lg:px-8 py-20">
      <SectionTitle kicker={kicker} title={c.title} sub={sub || 'Pick a time that works for you. Prefer to talk now? Give us a call.'} />
      <div className="mb-8"><PhoneButton type={c.phone} size="lg" testid={`${testid}-phone`} /></div>
      <GhlCalendar src={CALENDARS[kind]} id={c.id} title={c.title} testid={`${testid}-calendar`} />
    </section>
  );
};
